import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import DatasheetView from './DatasheetView';
import InputField from './InputField';
import { PersonAddTwoTone, PlaylistAddCheckTwoTone } from '@material-ui/icons';
import AssessmentGroupUsers from './AssessmentGroupUsers';
import Toggle from './Toggle';
import AssessmentGroupComps from './AssessmentGroupComps';

export default class AssessmentGroups extends Component {

    constructor(props) {
        super(props);
        this.reset_state = {
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            editing: false,
            error: false,
            error_message: '',
            querying: true,
            groups_array: [],
            show_dialogue: false,
            form_view: false,
            users_view: false,
            comps_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Assessment Group'
        }
        this.state = {  //Note: divisions and areas not reset
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            editing: false,
            designations: [],
            error: false,
            error_message: '',
            querying: true,
            divisions: [],
            areas: [],
            groups_array: [],
            show_dialogue: false,
            show_all: false,
            form_view: false,
            users_view: false,
            comps_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Assessment Group'            
        };
        this.datasheetFieldSpecs = [
            { field: 'employees', headerName: 'Individuals', width: 73, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton
                    onClick={()=>this.editUsers(parms)} 
                >
                    <PersonAddTwoTone/>
                </IconButton>
            )},
            { field: 'competencies', headerName: 'Competencies', width: 73, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => {
                if (parms.row.is_competency_group==='YES'){
                return (<IconButton
                    onClick={()=>this.editComps(parms)} 
                >
                    <PlaylistAddCheckTwoTone />
                </IconButton>
                )}
            }},
            { field: 'assessment_group', headerName: 'Assessment Group', width: 400},
            { field: 'is_competency_group', headerName: 'Competency Group?', align: 'center', sortable:false, width: 80},
        ]

        this.input_fieldSpecs = [
            {field: "assessment_group", headerName: "Assessment Group", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 3, f_maxLength: 200},
            {field: "is_competency_group", headerName: "Is this a Competency Group?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true},
        ]
    }

    componentDidMount = (show_all = false) => {

        //async get divisions... - once off
        if (this.state.divisions.length===0){  
            Gserv.sendCommand('query_divisions',this.props.gwt)
            .then(divisions => {
                // console.log('divisions :>> ', divisions);
                if (divisions.error){
                    console.log('error on return from Gserv (query_divisions) :>> ', divisions);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (divisions.Result!=="Success"&&divisions.statusCode!==204){
                    console.log('error on return from Gserv (query_divisions) :>> ', divisions);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {

                    this.setState({divisions: divisions.Records});
                }
            }); 
        }
 
        //async get areas... - once off
        if (this.state.areas.length===0){  
            Gserv.sendCommand('query_areas',this.props.gwt)
            .then(areas => {
                // console.log('areas :>> ', areas);
                if (areas.error){
                    console.log('error on return from Gserv (query_areas) :>> ', areas);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (areas.Result!=="Success"&&areas.statusCode!==204){
                    console.log('error on return from Gserv (query_areas) :>> ', areas);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({areas: areas.Records});
                }
            }); 
        }
        


        Gserv.sendCommand('query_assessment_groups',this.props.gwt,{
            show_all : show_all
        })
        .then(reply=>{
            // console.log('query_assessment_groups reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_assessment_groups) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_assessment_groups) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                //clean formats for display
                if (reply.Records){
                    let group_array = reply.Records;
                    for (var i=0;i<group_array.length;i++){
                        group_array[i].is_competency_group = group_array[i].is_competency_group? "YES" : "";
                    }
                }

                this.setState({querying:false, groups_array:reply.Records?reply.Records : []});

            }
        });
    };

    handleChildStateUpdate = (new_state) => {
        this.setState(new_state);
    }
    
    editAssessments = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row,assessments_view:true});
    }

    editUsers = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row,users_view:true, editing: true});
    }

    editComps = (parms) => {
        // console.log('edit comps with parms :>> ', parms);
        this.setState({current_record:parms.row,comps_view:true, editing: true});
    }

    processForm = (e) => {
        e.preventDefault();
        // console.log('this.state.form_data :>> ', this.state.form_data);
        this.setState({writing:true, primary_button_enabled:false});
        //set state updating here...
        
        if (this.state.current_record.id){
            //this is an update

            Gserv.sendCommand('update_assessment_group',this.props.gwt,{
                form_data : this.state.form_data,
                id : this.state.current_record.id
            })
            .then(reply => {
                // console.log('update reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (update_assessment_group) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409) {
                    console.log('error on return from Gserv (update_assessment_group) :>> ', reply);
                    this.setState({error:true,error_message:"A cycle with this code or name already exists.",querying:false});
                } else if (reply.Result!=="Success") {
                    console.log('error on return from Gserv (update_assessment_group) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState(this.reset_state);
                    this.componentDidMount(this.state.show_all);
                }
            });           

        } else {
            //this is a create
            Gserv.sendCommand('create_assessment_group',this.props.gwt,{
                form_data : this.state.form_data
            })
            .then(reply => {
                // console.log('create reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (create_assessment_group) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409){
                    console.log('error on return from Gserv (create_assessment_group) :>> ', reply);
                    this.setState({error:true,error_message:"A Group with this name already exists.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (create_assessment_group) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState(this.reset_state);
                    this.componentDidMount(this.state.show_all);
                }
            });
        }
    }

    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        switch (e.field) {
            case 'show_all':
                if (e.value !== this.state.show_all){
                    this.setState({show_all:e.value});
                    this.componentDidMount(e.value);
                }
                break;

            default:
                break;
        }
    }

    handleFieldUpdate = (fieldObj) => {
        // console.log('called field update...');
        if (fieldObj.value===''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;
        this.setState({form_data:myFormData});

        if(this.state.current_record[fieldObj.field]!==fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 
    }

    handleUpdate = (record) => {
        // console.log('record for update :>> ', record);
        this.setState({current_record:record.row,form_view:true,primary_button_enabled:false,primary_button_text:'Update Assessment Group'});
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);

        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({deleting:true,querying:true});
        Gserv.sendCommand('delete_assessment_group',this.props.gwt,{
            assessment_group_id: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (delete_assessment_group) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Message.includes('unable to delete system group')){
                console.log('error on return from Gserv (delete_assessment_group) :>> ', reply);
                this.setState({error:true,error_message:"Unable to delete: This is a special system group which cannot be deleted.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (delete_assessment_group) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState(this.reset_state);
                this.componentDidMount(this.state.show_all);
            }
        });

    }
    
    resetMe = () => {
        this.setState(this.reset_state);
        this.componentDidMount(this.state.show_all);
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                {!this.state.assessments_view&&!this.state.users_view&&!this.state.comps_view&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        // height:'22vh',
                        // maxWidth:680,
                        // minWidth:680
                        width:780
                    }}
                >
                    
                    <Grid container>

                        <Grid item xs={4}></Grid>

                        <Grid item xs={4}>
                            <Typography
                                color='primary'
                                style={{paddingTop:15}}
                            >
                                Assessment Groups
                            </Typography>
                            <Grid
                                container
                                direction='row'
                                justifyContent='space-evenly'
                                alignContent='center'
                                style={{padding:15}}
                            >
                                {!this.state.form_view&&!this.state.users_view&&   
                                <Button
                                    variant='contained'
                                    color='primary'
                                    type='submit'
                                    onClick={()=>this.setState({form_view:true,primary_button_text:'Create Assessment Group',current_record:{}})}
                                    disabled={this.state.form_view}
                                >
                                    Create
                                </Button>}
                            </Grid>
                        </Grid>

                        <Grid item xs={1}></Grid>

                        <Grid item xs={3} style={{paddingTop:20}}>
                            {!this.state.form_view&&!this.state.users_view&& 
                            <Toggle
                                fieldMap={{field: "show_all", headerName: "Show Competency Groups?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                                editRecord={{show_all: this.state.show_all}}
                                setField={this.handleToggleChange}
                            />}
                        </Grid>
                    </Grid>

                </Paper>
                </Grid>}

                <Grid item>
                    <Typography color='secondary' style={{Width:780,maxWidth:780, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

                {/* {this.state.querying&&
                <Grid item>
                    <br/>
                    <Settings className='icn-spinner' /> Querying...
                </Grid>} */}

                {/* Datagrid goes here */}
                {!this.state.form_view&&!this.state.assessments_view&&!this.state.users_view&&!this.state.comps_view&&
                <DatasheetView 
                    dataset={this.state.groups_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={true}
                    edit={true}
                    handleDelete={this.handleDelete}
                    handleEdit={this.handleUpdate}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={8}
                />}

                {this.state.form_view&&!this.state.assessments_view&&!this.state.users_view&&!this.state.comps_view&&
                <Paper
                    elevation={3}
                    style={{paddingBottom:'15px'}}
                >
                    <form onSubmit={this.processForm}>
                        <br/>
                        <Grid 
                            container 
                            direction='column'
                            alignItems='baseline'
                            justifyContent='center'
                            spacing={1}
                            style={{width:'100%', padding:'20px'}}
                        >

                            {/* <DropDown fieldMap={this.input_fieldSpecs[0]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={this.state.designations} disabled={this.state.writing}/> */}
                            {/* <InputField fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/> */}
                            
                            <div style={{width:'100%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[0]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            {/* Only display toggle if creating a new group */}
                            {Object.keys(this.state.current_record).length===0&&
                            <div style={{paddingTop:'15px'}}>
                                <Toggle fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>}

                        </Grid>
                        <Button 
                            color='primary'
                            variant='outlined'
                            disabled={!this.state.primary_button_enabled}
                            type='submit'
                            style={{marginTop:'20px'}}
                        >
                            {this.state.primary_button_text}
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.setState({form_view:false})}
                            style={{marginTop:'20px'}}
                        >
                            Cancel
                        </Button>
                    </form>
                </Paper>}  

                {this.state.users_view&&
                <AssessmentGroupUsers
                    group={this.state.current_record}
                    gwt={this.props.gwt}
                    setParentState={this.handleChildStateUpdate}
                />}

                {this.state.comps_view&&
                <AssessmentGroupComps
                    group={this.state.current_record}
                    divisions={this.state.divisions}
                    areas={this.state.areas} 
                    gwt={this.props.gwt}
                    setParentState={this.handleChildStateUpdate}
                />}

            </Grid>
        );
    }
    
}